import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./Item.local.scss";
import { DASHBOARD_SLIDES_STATUS, SPECIAL_CARACTERES } from "Config";
import {
  setSlideListFilterTitle,
  setSlidesListFilterIndicator,
  setSlideListPageSize,
  setSlideListFilterisPublic
} from "actions";
import { fetchIndicatorSuggestions } from "Thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import _ from "i18n";
import debounce from "lodash.debounce";

class SlideFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabsOptions: DASHBOARD_SLIDES_STATUS,
      statusLibrary: false,
      statusMyTemplate: false,
      librarySlidesStatus: [],
      myTemplateSlidesStatus: []
    };

    this.loadIndicatorSuggestions = debounce(
      this.loadIndicatorSuggestions,
      1000
    );
  }
  componentDidMount() {
    if (this.props.selectedStates.includes("ALL")) {
      this.props.dispatch(setSlideListFilterisPublic("", ""));
    }
    this.state.librarySlidesStatus.map((item, i) => {
      if (item.value === "SHARED") {
        this.state.librarySlidesStatus.splice(0, 2);
      }
    });
    this.state.myTemplateSlidesStatus.map((item, i) => {
      if (item.value === "CREATED") {
        this.state.myTemplateSlidesStatus.splice(0, 2);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.statusCounts !== this.props.statusCounts) {
      /**************** Library filter push ********** *****/
      if (
        this.props.selectedStates.includes("LIBRARY") &&
        !this.state.statusLibrary
      ) {
        this.state.librarySlidesStatus.push(
          { label: _("standard"), value: "STANDARD" },
          { label: _("share"), value: "SHARED" }
        );
        this.setState({
          statusLibrary: true
        });
      }
      /**************** My template filter push ********** *****/
      if (
        this.props.selectedStates.includes("MyTemplates") &&
        !this.state.statusMyTemplate
      ) {
        this.state.myTemplateSlidesStatus.push(
          { label: _("private"), value: "CREATED" },
          { label: _("public"), value: "Templates" }
        );
        this.setState({
          statusMyTemplate: true
        });
      }
      /**************** Remove children of my template and library isSelectedState is ALL ********** *****/
      if (
        (this.state.statusMyTemplate === true ||
          this.state.statusLibrary === true) &&
        this.props.selectedStates.includes("ALL")
      ) {
        this.state.myTemplateSlidesStatus.splice(0, 2);
        this.state.librarySlidesStatus.splice(0, 2);

        this.setState({
          statusLibrary: false,
          statusMyTemplate: false
        });
      }
      /**************** Remove children of my template isSelectedState is Library  ********** *****/
      if (
        this.state.statusMyTemplate === true &&
        this.props.selectedStates.includes("LIBRARY")
      ) {
        this.state.myTemplateSlidesStatus.splice(0, 2);
        this.setState({
          statusMyTemplate: false
        });
      }

      let tabsOptions = DASHBOARD_SLIDES_STATUS.map(({ label, value }) => {
        let countsCreatedSlide = parseInt(this.props.statusCounts["CREATED"])
          ? parseInt(this.props.statusCounts["CREATED"])
          : 0;
        return {
          label: label,
          value: value,
          count:
            value === "LIBRARY"
              ? parseInt(this.props.statusCounts["STANDARD"]) +
                parseInt(this.props.statusCounts["SHARED"])
              : value === "MyTemplates"
                ? countsCreatedSlide +
                  parseInt(this.props.statusCounts["Templates"])
                : this.props.statusCounts[value]
        };
      });

      let librarySlidesStatus = this.state.librarySlidesStatus.map(
        ({ label, value }) => {
          return {
            label: label,
            value: value,
            count: this.props.statusCounts[value]
          };
        }
      );
      let myTemplateSlidesStatus = this.state.myTemplateSlidesStatus.map(
        ({ label, value }) => {
          return {
            label: label,
            value: value,
            count: this.props.statusCounts[value]
              ? this.props.statusCounts[value]
              : 0
          };
        }
      );
      this.setState({
        tabsOptions: tabsOptions,
        slidesStatus: librarySlidesStatus,
        myTemplateSlidesStatus: myTemplateSlidesStatus
      });

      if (this.state.myTemplateSlidesStatus.length > 0) {
        librarySlidesStatus = myTemplateSlidesStatus;
      }
      this.props.handleChangeSlidesStatus(librarySlidesStatus);
    }
  }

  handleSelectIndicator = selected => {
    this.props.dispatch(setSlidesListFilterIndicator(selected));
  };
  handleSlideListPageSizeChange = selected => {
    this.props.dispatch(setSlideListPageSize(selected));
  };
  handleConvertAccentToCode(word) {
    SPECIAL_CARACTERES.map(item => {
      for (var i = 0; i < word.length; i++) {
        if (word[i] === item.letter) {
          if (i === 0) {
            word = this.setCharAt(word, i, item.code);
          } else {
            word = this.setCharAt(word, i, "\\" + item.code);
          }
        }
      }
    });
    return word;
  }
  setCharAt(str, index, char) {
    return str.substring(0, index) + char + str.substring(index + 1);
  }
  handleSearchInputChange(word) {
    let convertedCaractere = this.handleConvertAccentToCode(word);
    if (word.length > 2 || word.length === 0) {
      this.props.dispatch(setSlideListFilterTitle(convertedCaractere));
    }
  }
  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };
  loadIndicatorSuggestions = (searchWord, callback) => {
    let { lng } = this.props;
    // lng = lng.charAt(0).toUpperCase() + lng.slice(1);
    // alert(lng);
    this.props
      .dispatch(fetchIndicatorSuggestions({ searchWord, lng }))
      .then(res => {
        const indicators = res.value.data.data.map(t => {
          return { value: t.code, label: t["label"].fr, color: "#000000" };
        });
        // return indicators;
        callback(indicators);
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleOnClickTabFilter = value => {
    this.props.onTabChange(value);
  };

  render() {
    let { slidesFilter, pageSize, selectedStates, backOffice } = this.props;
    let { tabsOptions } = this.state;

    // let indicators = {};
    // if (this.props.suggestions) {
    //   indicators = this.props.suggestions.map(indicator => {
    //     return { label: indicator.label.fr, value: indicator.code };
    //   });
    // }

    let asyncFilters = [
      {
        placeholder: _("indicator"),
        handleChange: this.handleSelectIndicator,
        loadSuggestions: this.loadIndicatorSuggestions(),
        value: slidesFilter.indicator
      }
    ];

    return (
      <div className="row align-center medium-11">
        <div className={`medium-12 ${styles.filter_bar}`}>
          {/*<SlideActions />*/}
          <TTPFilterHorizontalBar
            onTabChange={this.handleOnClickTabFilter}
            tabs={backOffice ? [] : tabsOptions}
            selectedTab={selectedStates}
            asyncFilters={asyncFilters}
            searchInputValue={slidesFilter.name}
            searchPlaceholder={_("searchBySlideName")}
            pageSize={pageSize}
            handleResetFilter={this.handleResetFilter}
            handleListPageSizeChange={this.handleSlideListPageSizeChange}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            //isLibrary={selectedStates === "STANDARD"}
          />
        </div>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  suggestions: state.indicators.suggestions.items,
  slidesFilter: state.slideList.filter,
  statusCounts: state.slideList.statusCounts,
  pageSize: state.slideList.pageSize,
  lng: state.params.lng,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(SlideFilter);



// WEBPACK FOOTER //
// ./src/components/SlideList/SlideFilter.js